var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-call-screen-pop"},[_c('div',{staticClass:"call-screen-pop ma-2"},[_c('call-screen-pop')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }